export const translation = {
  "nav": {
    "home": "Home",
    "about": "About",
    "vendors": "Vendors",
    "riders": "Riders",
    "waitlist": "Waitlist",
    "contact": "Contact"
  },
  "hero": {
    "headline": "Discover and Order From Your Favorite Restaurants, Fast Food & Street Food",
    "subheadline": "Connecting customers, restaurants, fast food, street food and delivery riders across Douala and Yaounde.",
    "cta_waitlist": "Join the Waitlist",
    "cta_vendor": "Become a Vendor",
    "cta_rider": "Become a Rider"
  },
  "problem": {
    "title": "The Challenge",
    "subtitle": "Why food delivery is broken in Cameroon",
    "problem1_title": "Difficult Address Systems",
    "problem1_desc": "Many neighborhoods lack formal street addresses, making delivery a frustrating guessing game.",
    "problem2_title": "Limited Delivery Options",
    "problem2_desc": "Most delivery apps focus on big restaurants, leaving local chop bars and street food invisible.",
    "problem3_title": "Unreliable Delivery Services",
    "problem3_desc": "Long wait times, cold food, and inconsistent service leave customers disappointed.",
    "problem4_title": "No Visibility for street food, restaurants and fast food",
    "problem4_desc": "The best meals are often street food that remain hidden beyond their local area."
  },
  "solution": {
    "title": "How Mayouk Works",
    "subtitle": "Simple, fast, and designed for Cameroon",
    "step1_title": "Place Your Order",
    "step1_desc": "Browse local vendors and order your favorite meals through the app.",
    "step2_title": "Rider Accepts",
    "step2_desc": "A nearby motorcycle rider picks up your request and heads to the selected restaurant, street food or fast food and you can track his route live in the application.",
    "step3_title": "Pay with Mobile Money",
    "step3_desc": "Complete your payment securely through MTN Mobile Money or Orange Money.",
    "step4_title": "Fast Delivery",
    "step4_desc": "Your food arrives hot and fresh, delivered by a trusted local rider who knows your neighborhood."
  },
  "about": {
    "title": "About Mayouk",
    "subtitle": "A service designed from the street, for all",
    "description1": "Mayouk represents the warmth of direct human connection, the familiar relationship between customers and trusted restaurants and fast food in Douala and Yaounde.",
    "description2": "We were born from a simple observation: the best meals are often sold by street food, chop bars, fast food than large restaurants.",
    "description3": "By leveraging motorcycle taxi networks that already know every street and using Mobile Money, we bridge traditional local markets with modern digital convenience.",
    "mission1_title": "Supporting Local Vendors",
    "mission1_desc": "We give street food the visibility they deserve.",
    "mission2_title": "Empowering Riders",
    "mission2_desc": "We create delivery opportunities for motorcycle taxi drivers.",
    "mission3_title": "Authentic Local Meals",
    "mission3_desc": "We deliver the real taste of Cameroonian restaurants and street food.",
    "mission4_title": "Building Community Trust",
    "mission4_desc": "We foster the trusted relationships that make local food special."
  },
  "vendors": {
    "title": "For Restaurants and street food",
    "subtitle": "Grow your business with Mayouk",
    "benefit1_title": "Increased Visibility",
    "benefit1_desc": "Reach customers beyond your neighborhood who never knew you existed.",
    "benefit2_title": "More Customers",
    "benefit2_desc": "Tap into a growing network of hungry customers looking for authentic local food.",
    "benefit3_title": "Easy Onboarding",
    "benefit3_desc": "Get started in minutes with our restaurants registration process.",
    "benefit4_title": "No Hidden Startup Fees",
    "benefit4_desc": "Transparent pricing with no surprise costs. You keep what you earn.",
    "benefit5_title": "Mobile Money Integration",
    "benefit5_desc": "Receive payments directly to your MTN Mobile Money or Orange Money account.",
    "cta": "Become a Vendor"
  },
  "riders": {
    "title": "For Delivery Riders",
    "subtitle": "Earn more with your motorcycle",
    "benefit1_title": "Flexible Hours",
    "benefit1_desc": "Work when you want. No schedules, no quotas. You are your own boss.",
    "benefit2_title": "More Opportunities",
    "benefit2_desc": "Connect to food delivery requests alongside your existing passenger rides.",
    "benefit3_title": "Additional Income",
    "benefit3_desc": "Boost your daily earnings with reliable delivery requests in your area.",
    "benefit4_title": "Easy Registration",
    "benefit4_desc": "Simple sign-up process. Start accepting deliveries within 24 hours.",
    "cta": "Join the Rider Network"
  },
  "waitlist": {
    "title": "Join the Waitlist",
    "subtitle": "Be the first to experience Mayouk when we launch in your city.",
    "full_name": "Full Name",
    "phone": "Phone Number",
    "neighborhood": "Neighborhood",
    "status": "I am a",
    "status_customer": "Customer",
    "status_vendor": "Vendor",
    "status_rider": "Rider",
    "submit": "Join the Waitlist",
    "success": "Thank you! You have been added to our waitlist. We will contact you soon.",
    "contact_title": "Contact Us",
    "phone_label": "Phone",
    "whatsapp_label": "WhatsApp",
    "email_label": "Email",
    "location_label": "Location",
    "phone_value": "+237 681 17 25 45",
    "whatsapp_value": "+237 681 17 25 45",
    "email_value": "info@mayouk.com",
    "location_value": "Akwa, Douala, Cameroon"
  },
  "footer": {
    "about": "About",
    "about_text": "Mayouk connects customers, local food vendors, and motorcycle delivery riders in Douala and Yaounde, Cameroon.",
    "navigation": "Navigation",
    "contact": "Contact",
    "social": "Follow Us",
    "copyright": "2026 MAYOUK. All Rights Reserved.",
    "tagline": "Designed from the street, for all.",
    "privacy": "Privacy Policy",
    "terms": "Terms of Service"
  },
  "language": {
    "en": "English",
    "fr": "French"
  }
};

export default translation;